import * as yup from 'yup';
import {
  firstName,
  getEmailSchema,
  idNumber,
  lastName,
  lastNameSecond,
  password,
  passwordConfirmation,
  taxIdNumber,
} from 'utils/schemaUtils';

export default yup.object({
  email: getEmailSchema({ section: 'signup' }),
  firstName,
  idNumber,
  lastName,
  password,
  passwordConfirmation,
  secondLastName: lastNameSecond,
  taxIdNumber,
});
